import {
  LightBlueContainer,
  WhiteContainer,
} from "../../styled/Container.styled";
import { useGetTripByIdQuery } from "../../../feature/booking/bookingApiSlice";
import { useGetTransactionByIdQuery } from "../../../feature/Transactions/transactionApiSlice";
import TextArea from "antd/lib/input/TextArea";
import { Card, Col, DatePicker, Divider, Form, Input, Row } from "antd";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

import dayjs from "dayjs";
import constants from "../../../constants";
const defaultImage: string = require("../../../assets/logo/defaultImage.svg").default;

const formatAmount = (amount?: number | null) =>
  amount === undefined || amount === null ? "" : Number(amount).toFixed(2);

function BookingDetails() {
  let { id } = useParams();
  const [form] = Form.useForm();
  const { data,isLoading,isError } = useGetTripByIdQuery(id);
  const { data: transactionData } = useGetTransactionByIdQuery(id);

  useEffect(() => {
    if (!data) return;
    const transaction = transactionData?.data;
    form.setFieldsValue({
      name: data.data.userName,
      phoneNumber: data.data.userNumber,
      email: data.data.userEmail,
      bookingStatus: data.data.tripStatus,
      bookingType: data.data.tripType,
      bookingDate: dayjs(data.data.date),
      routeFrom: data.data.fromDirectionAddress.address,
      routeTo: data.data.toDirectionAddress.length > 0 ? data.data.toDirectionAddress[0].address : "",
      driverName: transaction?.driverName,
      driverPhoneNumber: transaction?.driverPhoneNumber,
      vehicleNumber: transaction?.vehicleNumber,
      actualTripAmount: formatAmount(transaction?.actualTripAmount ?? transaction?.transactionAmount),
      amountPaidByRider: formatAmount(transaction?.amountPaidByRider ?? transaction?.transactionAmount),
      couponApplied: transaction?.couponCode
        ? `${transaction.couponName} (${transaction.couponCode})`
        : "No coupon applied",
      couponValue: transaction?.couponCode ? formatAmount(transaction.couponValue) : "-",
    });
  }, [form, data, transactionData]);

  return (
    <>
      { !isError && !isLoading && data && (
      <Form disabled form={form}>
        <LightBlueContainer>
          <WhiteContainer>
            <Row gutter={[32, 22]}>
              <Col span={12}>
                <Card>
                  <img
                    src={`${constants.baseImgUrl}${data.data.userImage}`}
                    onError={(e) => {
                      (e.target as HTMLSourceElement).src = defaultImage;
                    }}
                    alt=" User"
                    style={{
                      width: "150px",
                      height: "100px",
                      border: "2px solid #BBD4FF",
                    }}
                  />
                </Card>

                <label>Name</label>
                <Form.Item name="name">
                  <Input />
                </Form.Item>

                <label>Phone Number</label>
                <Form.Item name="phoneNumber">
                  <Input maxLength={10} />
                </Form.Item>

                <label>Email</label>
                <Form.Item name="email">
                  <Input />
                </Form.Item>

                {transactionData?.data.driverName && (
                  <>
                    <label>Driver Name</label>
                    <Form.Item name="driverName">
                      <Input readOnly />
                    </Form.Item>

                    <label>Driver Phone Number</label>
                    <Form.Item name="driverPhoneNumber">
                      <Input readOnly />
                    </Form.Item>

                    <label>Vehicle Number</label>
                    <Form.Item name="vehicleNumber">
                      <Input readOnly />
                    </Form.Item>
                  </>
                )}
              </Col>
              <Col span={12} className="mt-5">
                <label>Booking Status</label>
                <Form.Item name="bookingStatus">
                  <Input />
                </Form.Item>

                <label>Booking Type</label>
                <Form.Item name="bookingType">
                  <Input />
                </Form.Item>

                <label>Booking Date</label>
                <Form.Item name="bookingDate">
                  <DatePicker className="w-100" format={"DD/MM/YYYY"} />
                </Form.Item>

                <label>Route-From</label>
                <Form.Item name="routeFrom">
                  <TextArea rows={5}  disabled/>
                </Form.Item>

                <label>Route-To</label>
                <Form.Item name="routeTo">
                  <TextArea rows={5} disabled/>
                </Form.Item>
              </Col>
            </Row>

            {transactionData?.data && (
              <>
                <Divider orientation="left">Fare Details</Divider>
                <Row gutter={[32, 22]}>
                  <Col span={12}>
                    <label>Actual Trip Amount (incl. GST)</label>
                    <Form.Item name="actualTripAmount">
                      <Input prefix="₹" readOnly />
                    </Form.Item>

                    <label>Amount Paid by Rider</label>
                    <Form.Item name="amountPaidByRider">
                      <Input prefix="₹" readOnly />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <label>Coupon Applied</label>
                    <Form.Item name="couponApplied">
                      <Input readOnly />
                    </Form.Item>

                    <label>Coupon Amount</label>
                    <Form.Item name="couponValue">
                      <Input prefix="₹" readOnly />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </WhiteContainer>
        </LightBlueContainer>
      </Form>
      )}
    </>
  );
}

export default BookingDetails;
